<div class="container-fluid d-flex flex-column h-100 pb-3">
  <div class="page-head">
    <h1 class="page-title">Admin - Compliance Exempt Vendor Setup</h1>
    <div class="action-row">
      <button class="btn btn-primary" (click)="addExemptType()">
        Add compliance exempt vendor type
      </button>
    </div>
  </div>

  <div class="row flex-grow-1">
    <div class="col">
      <app-exempt-vendor-types-grid
        [gridName]="'ClientExemptVendorType'"
        [suppliedQueryData]="suppliedGridQueryData"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        [(reloadGridData)]="reloadGrid"
        (actionEvent)="action($event)"
      ></app-exempt-vendor-types-grid>
    </div>
  </div>
</div>
